/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Task_Email_SentInputs */

const en_task_email_sent = /** @type {(inputs: Task_Email_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Email sent on ${i?.date}`)
};

const pt_br2_task_email_sent = /** @type {(inputs: Task_Email_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E-mail enviado em ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Email sent on {date}" |
*
* @param {Task_Email_SentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_email_sent = /** @type {((inputs: Task_Email_SentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Email_SentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_email_sent(inputs)
	return pt_br2_task_email_sent(inputs)
});